export const CONSENT_PURPOSE = "SMS";
export const MARKETING_PURPOSE = "Promotional Text";
export const DEFAULT_COUNTRY = "US";

export const CONTACT_METHODS_STATUS = {
  DUPLICATE_PHONE_NUMBER: "DUPLICATE_PHONE_NUMBER",
  INVALID_PHONE_NUMBER: "INVALID_PHONE_NUMBER",
};

export const POPUP_SLIDES = {
  SMS_OPT_IN: "smsOptIn",
  ZIP_CODE: "zipCode",
};
